let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kRNym")).then(() => parcelRequire('28wDW'));